import React from "react"

import config from "../../config"
import ExternalLink from "./ExternalLink"

function TicketLink(props) {
  // const pdfLink = `${config.ticket.url}/${props.id}?kind=standard&o=pdf`;
  const htmlLink = `${config.ticket.url}/${props.id}`
  return (
    <ExternalLink to={htmlLink}>
      {props.children}
    </ExternalLink>
  )
}

export default TicketLink